import axios from 'axios'
import {
  setTransactions,
  setNewTransaction,
  setBalances,
  setComission,
  setMassivePaymentExcelValidation,
  setMassivePaymentExcelPayment,
  setMassivePaymentExcelStatus,
} from '../reducers/transactions.reducer'

const URL = process.env.REACT_APP_API_PORTAL

// PORTAL / PAYONEER / TENUI
export const getTransactions =
  ({ transactionType, transactionNumber, credentialId = '' }) =>
  async (dispatch) => {
    const token = localStorage.getItem('tokenContraPago')
    const finalUrl =
      transactionType === 'Portal'
        ? `${URL}gettransaction/wallet`
        : transactionType === 'Payoneer'
        ? `${process.env.REACT_APP_CORE_PAYONEER_URL}/transaccions&size=10&page=1`
        : `${
            process.env.REACT_APP_CORE_TENUI_URL
          }/transaccionesespeciales?page=1&elements=10${
            transactionNumber ? `&numerotransaccion=${transactionNumber}` : ''
          }`

    const config = {
      method: transactionType === 'Tenui' ? 'GET' : 'POST',
      url: finalUrl,
      headers: {
        'Content-Type': 'application/json',
        ...(transactionType !== 'Portal' && {
          Authorization: `Bearer ${token}`,
        }),
      },
      data: {
        id: credentialId,
        chainId: 'solana',
      },
    }

    dispatch(
      setTransactions({
        data: null,
        isLoading: true,
        isError: null,
      })
    )

    axios(config)
      .then(function (response) {
        dispatch(
          setTransactions({
            data: response?.data?.transactions || response?.data?.data || [],
            isLoading: false,
            isError: response?.data?.error,
          })
        )
      })
      .catch(function (error) {
        dispatch(
          setTransactions({
            data: null,
            isLoading: false,
            isError: true,
          })
        )
      })
  }

export const sendTokens = ({
  shareWallet,
  amount,
  destinationWallet,
  network,
  coin,
  clientApiKey,
  fromPubkey,
}) => {
  return async (dispatch) => {
    dispatch(
      setNewTransaction({
        data: null,
        isLoading: true,
        isError: null,
      })
    )

    const urlByCoin = coin?.toLowerCase() === 'usdc' ? '' : coin?.toLowerCase()
    const urlWithSlash = network?.toLowerCase() === 'polygon' ? '' : '/'
    const finalUrl = `${URL}createtransacction${network?.toLowerCase()}${urlWithSlash}${urlByCoin}`
    // https://apiportal.develone.com/api/createtransacctiontron/usdt TRON USDT
    // https://apiportal.develone.com/api/createtransacctiontron/trx TRON TRX

    // https://apiportal.develone.com/api/createtransacctionpolygon POLYGON USDC
    // https://apiportal.develone.com/api/createtransacctionpolygonpol POLYGON POL
    // https://apiportal.develone.com/api/createtransacctionpolygonusdt POLYGON USDT

    const config = {
      method: 'POST',
      url: finalUrl,
      headers: {
        'Content-Type': 'application/json',
      },
      data: {
        clientApiKey,
        fromPubkey, // user wallet direction
        to: destinationWallet,
        amount: amount,
        share: shareWallet,
      },
    }

    axios(config)
      .then(function (response) {
        dispatch(
          setNewTransaction({
            data: response?.data,
            isLoading: false,
            isError: false,
          })
        )
      })
      .catch(function (error) {
        dispatch(
          setNewTransaction({
            data: error?.response?.data,
            isLoading: false,
            isError: true,
          })
        )
      })
  }
}

export const getBalances = (credentialId) => async (dispatch) => {
  dispatch(
    setBalances({
      data: null,
      isLoading: true,
      isError: null,
    })
  )

  if (!credentialId) {
    dispatch(
      setBalances({
        data: null,
        isLoading: false,
        isError: true,
      })
    )
    return
  }

  const config = {
    method: 'POST',
    url: `${URL}getbalance`,
    headers: {
      'Content-Type': 'application/json',
    },
    data: {
      clientId: credentialId,
    },
  }

  axios(config)
    .then(function (response) {
      dispatch(
        setBalances({
          data: response?.data,
          isLoading: false,
          isError: false,
        })
      )
    })
    .catch(function (error) {
      dispatch(
        setBalances({
          data: null,
          isLoading: false,
          isError: true,
        })
      )
    })
}

export const getTransactionsByUserIdOrTransactionId =
  ({ userId, transactionId, page = 1, elements = 10 }) =>
  async (dispatch) => {
    dispatch(
      setTransactions({
        data: null,
        isLoading: true,
        isError: null,
      })
    )

    const isTransactionDetail = !!transactionId

    let url = `${process.env.REACT_APP_API_PORTAL}comprobantesportal?page=${page}&elements=${elements}&`
    if (userId) {
      url += `userid=${userId}`
    } else if (transactionId) {
      url += `signedtx=${transactionId}`
    }

    try {
      const response = await axios.get(url, {
        headers: {
          'Content-Type': 'application/json',
        },
      })
      dispatch(
        setTransactions({
          data: isTransactionDetail
            ? response?.data?.data[0] || []
            : response?.data?.data || [],
          isLoading: false,
          isError: null,
          pagination: {
            page: response?.data?.pagination?.page,
            lastPage:
              Math.ceil(
                response?.data?.pagination?.totalObjects /
                  response?.data?.pagination?.elements
              ) || 1,
          },
        })
      )
    } catch (error) {
      dispatch(
        setTransactions({
          data: null,
          isLoading: false,
          isError: true,
        })
      )
    }
  }

export const getComission = () => async (dispatch) => {
  var token = localStorage.getItem('tokenContraPago')

  var configGetEmpresa = {
    method: 'GET',
    maxBodyLength: Infinity,
    url: `${process.env.REACT_APP_CORE_TENUI_URL}/empresa?empresaid=154`,
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
    },
  }

  dispatch(
    setComission({
      data: null,
      isLoading: true,
      isError: null,
    })
  )

  axios(configGetEmpresa)
    .then(function (response) {
      dispatch(
        setComission({
          data: response?.data?.data?.[0]?.comision_crypto_out,
          isLoading: false,
          isError: null,
        })
      )
    })
    .catch(function (error) {
      dispatch(
        setComission({
          data: null,
          isLoading: false,
          isError: true,
        })
      )
    })
}

// MASSIVE PAYMENTS
// WITH EXCEL

// VALIDATE EXCEL AND PROCESS TRANSACTIONS THAT ARE VALID AND INVALID
export const validateExcelMassivePayment = (file, userId) => {
  return async (dispatch) => {
    dispatch(
      setMassivePaymentExcelValidation({
        data: null,
        isLoading: true,
        errors: [],
      })
    )

    const formData = new FormData()
    formData.append('file', file)

    const config = {
      method: 'POST',
      url: `${URL}pagosmasivos/${userId}`,
      data: formData,
    }

    axios(config)
      .then(function (response) {
        dispatch(
          setMassivePaymentExcelValidation({
            data: response?.data,
            isLoading: false,
            errors: response?.data?.errores || [],
          })
        )
      })
      .catch(function (error) {
        dispatch(
          setMassivePaymentExcelValidation({
            data: null,
            isLoading: false,
            errors: error?.response?.data?.errores || [],
          })
        )
      })
  }
}

// MAKE PAYMENTS WITH EXCEL
export const createExcelMassivePayment = (userId, massivePaymentId) => {
  return async (dispatch) => {
    dispatch(
      setMassivePaymentExcelPayment({
        data: null,
        isLoading: true,
        error: null,
      })
    )

    const config = {
      method: 'POST',
      url: `${URL}pagosmasivos/${userId}/${massivePaymentId}`,
    }

    axios(config)
      .then(function (response) {
        dispatch(
          setMassivePaymentExcelPayment({
            data: response?.data?.message || null,
            isLoading: false,
            error: null,
          })
        )
      })
      .catch(function (error) {
        dispatch(
          setMassivePaymentExcelPayment({
            data: null,
            isLoading: false,
            error: error?.response?.data?.message || null,
          })
        )
      })
  }
}

// GET MASSIVE PAYMENTS BY USER - TO SEE THE STATUS OF THE LAST MASSIVE PAYMENT
export const getExcelMassivePaymentsStatus = (userId, page = 1) => {
  return async (dispatch) => {
    dispatch(
      setMassivePaymentExcelStatus({
        data: null,
        isLoading: true,
        errors: [],
      })
    )

    const config = {
      method: 'GET',
      url: `${URL}pagosmasivos`,
      params: {
        usuario_id: userId,
        elements: 5,
        page,
      },
      headers: {
        Authorization: `Bearer ${localStorage.getItem('tokenContraPago')}`,
      },
    }

    axios(config)
      .then(function (response) {
        dispatch(
          setMassivePaymentExcelStatus({
            data: response?.data,
            isLoading: false,
            error: null,
          })
        )
      })
      .catch(function (error) {
        dispatch(
          setMassivePaymentExcelStatus({
            data: null,
            isLoading: false,
            error: error?.response?.data?.message || null,
          })
        )
      })
  }
}
